import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Form, Input, Radio } from 'antd';
import PaymentMethodInfo from './component/PaymentMethodInfo';
import BankTransfer from './component/BankTransfer';
import UPI from './component/UPI';
import LoadableButton from '../../../../components/buttons/LoadableButton';
import { GetCredentialsApi, GetWalletApi } from '../../../../api/request/wallet/withdraw';
import Paypal from './component/Paypal';
import Crypto from './component/Crypto';
import WithdrawRequest from './WithdrawRequest';
import CashWithdraw from './component/CashWithdraw';
import { GetCurrentCurrencyRateApi } from '../../../../api/request/wallet/cashdeposit';

const Withdraw2 = () => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state?.user);
    const [walletDetails, setWalletDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [amount, setAmount] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [step, setStep] = useState(1);
    const [isRefresh, setIsRefresh] = useState(false);
    const [credentials, setCredentials] = useState([]);
    const [currencyRate, setCurrencyRate] = useState(null);

    const paymentGateways = [
        {
            name: "BankTransfer",
            value: 1,
            fees: 0,
            processingTime: "1 H",
            paymentLogoUrl: "/assets/images/bank.png"
        },
        {
            name: "Cash",
            value: 6,
            fees: 0,
            processingTime: "1 H",
            paymentLogoUrl: "/assets/images/bank.png"
        },
        // {
        //     name: "UPI",
        //     value: 2,
        //     fees: 0,
        //     processingTime: "1 H",
        //     paymentLogoUrl: "/assets/images/upi.png"
        // },
        // {
        //     name: "Paypal",
        //     value: 3,
        //     fees: 0,
        //     processingTime: "1 H",
        //     paymentLogoUrl: "/assets/images/paypal.png"
        // },
        // {
        //     name: "Crypto",
        //     value: 4,
        //     fees: 0.0,
        //     processingTime: "1 H",
        //     paymentLogoUrl: "/assets/images/crypto.png"
        // }
    ];

    const getWalletDetails = async () => {
        setIsLoading(true);
        try {
            const params = { RuleType: 'Withdraw' }
            const { data } = await GetWalletApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) setWalletDetails(data?.data)
        } catch (error) {
            setIsLoading(false);
        }
    }

    const getCredentials = async () => {
        try {
            const { data } = await GetCredentialsApi();
            if (data?.success) {
                setCredentials(data?.data);
            }
        } catch (error) { }
    }
    const getCurrentCurrencyRate = async () => {
        try {
            const { data } = await GetCurrentCurrencyRateApi();
            if (data?.success) setCurrencyRate(data?.data);
        } catch (error) {
        }
    }
    
    useEffect(() => {
        getWalletDetails();
        getCredentials();
        getCurrentCurrencyRate();
    }, []);

    const validateAmount = (_, value) => {
        if (!value) {
            setStep(1);
            return Promise.reject(new Error('Please enter amount.'));
        }

        if (Number(value) <= 0) {
            setStep(1);
            return Promise.reject(new Error('Please enter a valid amount.'));
        }

        if (walletDetails?.isRuleActive) {
            if (amount < walletDetails?.minAmount) {
                setStep(1);
                return Promise.reject(new Error(`Amount must be at least $${walletDetails?.minAmount}.`));
            }
            if (amount > walletDetails?.maxAmount) {
                setStep(1);
                return Promise.reject(new Error(`Amount cannot exceed $${walletDetails?.maxAmount}.`));
            }
        }

        return Promise.resolve();
    };

    const handleSubmit = (values) => {
        if (values?.amount && values?.paymentMethod) setStep(2);
    }

    const resetAll = () => {
        form.resetFields();
        setAmount(0);
        setPaymentMethod(null);
        setStep(1);
        setIsRefresh(true);
    }

    const renderStep = () => {
        switch (paymentMethod?.name) {
            case "BankTransfer":
                return <BankTransfer amount={amount} resetAll={resetAll} details={credentials?.bankDetails} />;
            case "UPI":
                return <UPI amount={amount} resetAll={resetAll} />;
            case "Paypal":
                return <Paypal amount={amount} resetAll={resetAll} />;
            case "Crypto":
                return <Crypto amount={amount} resetAll={resetAll} />;
            case "Cash":
                return <CashWithdraw amount={amount} resetAll={resetAll} details={credentials?.mobileNumbers} />;
            default:
                return null;
        }
    }

    return (
        <div className='space-y-5'>
            <PaymentMethodInfo walletDetails={walletDetails} paymentMethod={paymentMethod} />

            <div className='grid grid-cols-8 gap-5'>
                <div className='col-span-8 xl:col-span-3 border-2 border-light rounded-lg p-5'>
                    <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
                        <Form.Item
                            name='amount'
                            label={<span className="text-lg text-gray-500 font-medium">Amount In USD<span className='text-lg primary font-semibold'> (${currencyRate?.baseCurrencyRate} = {currencyRate?.targetCurrencyWithdrawRate} {currencyRate?.targetCurrency})</span></span>}
                            rules={[{ validator: validateAmount }]}
                        >
                            <Input type='number' placeholder="Amount in USD" size='large' onChange={(e) => setAmount(e?.target?.value)} />
                        </Form.Item>

                        <Form.Item
                            name="paymentMethod"
                            label={<span className="text-lg text-gray-500 font-medium">Select Payment Method</span>}
                            rules={[{ required: true, message: 'Please select a payment method.' }]}
                            required={false}
                        >
                            <Radio.Group className="w-full grid grid-cols-1 md:grid-cols-2 gap-3">
                                {paymentGateways?.map((item, index) => (
                                    <Radio
                                        key={index}
                                        value={item?.value}
                                        className={`flex items-center gap-1 border-2 rounded-lg p-3 m-0 ${paymentMethod?.value === item?.value ? 'border-primary' : 'border-light'}`}
                                        onChange={() => setPaymentMethod(item)}
                                    >
                                        <div className='flex items-center gap-3'>
                                            <img
                                                src={item?.paymentLogoUrl}
                                                alt="Icon"
                                                className="h-[35px] w-[35px] object-contain"
                                            />
                                            <span className='break-all'>{item?.name}</span>
                                        </div>
                                    </Radio>
                                ))}
                            </Radio.Group>
                        </Form.Item>

                        <div className='flex items-center justify-end'>
                            <LoadableButton
                                className='bg-primary text-sm text-white font-semibold rounded-lg px-4 py-2 uppercase themeHover duration-500'
                                type="submit"
                                lable='Next'
                            />
                        </div>
                    </Form>
                </div>

                <div className='col-span-8 xl:col-span-5 border-2 border-light rounded-lg p-5'>
                    {step === 2 ? (
                        <>
                            {renderStep()}
                        </>
                    ) : (
                        <div className='h-full flex items-center justify-center'>
                            <p className='text-lg text-gray-500'>Please select a payment method.</p>
                        </div>
                    )}
                </div>
            </div>

            <WithdrawRequest isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
        </div>
    )
}

export default Withdraw2